import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
// Serialization
import { deserialize, serialize } from 'serializr';
import { doorSchema } from './schemas';
// Custom
import { findInList } from '../utils/Tools';

/**
* Serialization
*/
const serializerKey = 'door';

const deserializeDoor = (data) => deserialize(doorSchema, data);

const serializeDoor = ({
  name, usage, type, scenarioId,
}) => ({
  [serializerKey]: {
    ...serialize(doorSchema, {
      name: _defaultTo(name, null),
      usage: _defaultTo(usage, null),
      type: _defaultTo(type, null),
      scenario_id: _defaultTo(scenarioId, null),
    }),
  },
});

/**
* Lists
*/
const doorUsagesList = [
  {
    key: 'vehicle',
    value: 'vehicle',
    labelId: 'door.usage.vehicle',
    icon: 'dusageVeh',
    weight: 1,
  },
  {
    key: 'pedestrian',
    value: 'pedestrian',
    labelId: 'door.usage.pedestrian',
    icon: 'dusagePed',
    weight: 0,
  },
];

const doorTypesList = [
  {
    key: 'door',
    value: 'door',
    labelId: 'door.type.door',
  },
  {
    key: 'fence',
    value: 'fence',
    labelId: 'door.type.fence',
  },
  {
    key: 'gate',
    value: 'gate',
    labelId: 'door.type.gate',
  },
];

/**
* Utils
*/
const sortDoors = (doors, fields = ['name', 'type', 'usage'], dirs = ['asc', 'asc', 'asc']) => (_orderBy(doors, fields, dirs));

const doorTitle = (doorData) => _get(doorData, 'name', '');

const doorUsage = (door) => findInList(doorUsagesList, 'value', door, 'usage');
const doorType = (door) => findInList(doorTypesList, 'value', door, 'type');

/**
* Model
*/
const door = {
  // Name
  name: 'door',

  // Serialization
  deserialize: deserializeDoor,
  serialize: serializeDoor,

  // Sort elements
  sortElements: sortDoors,

  // Lists
  usagesList: doorUsagesList,
  typesList: doorTypesList,

  // Utils
  title: doorTitle,
  usage: doorUsage,
  type: doorType,
};

module.exports = door;



// WEBPACK FOOTER //
// ./models/door.js